export const RecipeRow = {
  transclude: true,

  bindings: {
    recipe: '<',
    leftOvers: '<',
    cookup: '<',
    disabled: '<',
    onPreview: '&',
  },

  template: `
    <div class="recipe-row align-items-center"
      ng-class="{ 'recipe-row--disabled': $ctrl.disabled }">
      <img class="recipe-row-thumb mr-3 pointer"
        ng-click="$ctrl.onPreview({ recipe: $ctrl.recipe })"
        ng-src="{{ ($ctrl.recipe.imageUrl.thumb2x || $ctrl.recipe.image.thumb2x) | assetSrc }}" />
      <a ui-sref="recipes({ recipeId: $ctrl.recipe.id })"
        ng-disabled="$ctrl.disabled"
        class="recipe-row-title d-flex align-items-center pr-2">
        <h6 class="recipe-name d-inline-block font-weight-semibold m-0">
          {{ $ctrl.recipe.name }}
        </h6>
        <small class="badge badge-primary text-white ml-2" ng-show="$ctrl.leftOvers">
          Leftovers
        </small>
        <span class="badge fa-badge ml-2" ng-show="$ctrl.cookup">
          <i class="fa fa-lg icon-cookup text-teal-dark"></i>
        </span>
      </a>
      <ul class="recipe-row-meta mb-0 mr-2 pl-0 d-flex align-items-center">
        <li ng-hide="$ctrl.disabled">
          <i class="icon-serves"></i>
          &times;{{ $ctrl.recipe.serves }}
        </li>
        <li ng-hide="$ctrl.disabled">
          <i class="icon-cook-time"></i>
          {{ $ctrl.recipe.prepTimeMins + $ctrl.recipe.cookingTimeMins }}
          <span class="d-none d-md-inline">min</span>
        </li>
        <li ng-hide="$ctrl.disabled">
          <i class="icon-calories"></i>
          {{ $ctrl.recipe.caloriesPerServe }}
          <span class="d-none d-md-inline">Cal</span>
        </li>
        <li class="last" ng-transclude></li>
      </ul>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Recipe/RecipeRow.js